export const NotFound = () => {
  return <h2 className='pt-20 font-bold text-center text-9xl'>404</h2>;
};
